import React from 'react';
import Stack from 'components/core/Stack';
import { useTheme } from '@mui/joy';
import { useDispatch } from 'react-redux';


import Typography from 'components/core/Typography';
import Input from 'components/core/Input';
import Button from 'components/core/Button';

import authActions from 'actions/authActions';


const newUserDefault = {
    firstName: '',
    lastName: '',
    email: ''
}

const AddUserForm = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const [newUser, setNewUser] = React.useState(newUserDefault);
    const [errors, setErrors] = React.useState({})


    const handleChange = (key, value) => {
        setNewUser({
            ...newUser,
            [key]: value
        })
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        setErrors({})

        if (!newUser.firstName) {
            setErrors({ ...errors, firstName: 'First Name is required' })
            return;
        }
        if (!newUser.lastName) {
            setErrors({ ...errors, lastName: 'Last Name is required' })
            return;
        }
        if (!newUser.email) {
            setErrors({ ...errors, email: 'Email is required' })
            return;
        }
        dispatch(authActions.createUser(newUser))
    }

    return (
        <Stack>
            <Typography variant="h2">Add User</Typography>
            <form onSubmit={handleSubmit}>
                <Stack spacing={2}>
                    <Input
                        label="First Name"
                        value={newUser.firstName}
                        onChange={(value) => handleChange('firstName', value)}
                        error={errors[`firstName`]}
                    />
                    <Input
                        label="Last Name"
                        value={newUser.lastName}
                        onChange={(value) => handleChange('lastName', value)}
                        error={errors[`lastName`]}
                    />
                    <Input
                        label="Email"
                        value={newUser.email}
                        onChange={(value) => handleChange('email', value)}
                        error={errors[`email`]}
                    />
                    <Button type="submit">Add User</Button>
                </Stack>
            </form>
        </Stack>
    );
}

export default AddUserForm;